#include <fog_vertex>
vec4 worldPosition2 = vec4( transformed, 1.0 );
worldPosition2 = modelMatrix * worldPosition2;
vPositionW  = vec3(worldPosition2);